import styled from 'styled-components';

export const WrapperFilter = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  .title-filter {
    font-size: 14px;
    font-weight: bold;
    margin-left: 5px;
  }
`;

export const WrapperRegion = styled.div`
  padding: 10px;
  .subtitle-filter {
    font-size: 14px;
    font-weight: bold;
    margin-left: 5px;
  }
`;

export const WrapperGroup = styled.div`
  padding: 10px;
  .subtitle-filter {
    font-size: 14px;
    font-weight: bold;
    margin-left: 5px;
  }
`;

export const WrapperService = styled.div`
  padding: 10px;
  .subtitle-filter {
    font-size: 14px;
    font-weight: bold;
    margin-left: 5px;
  }
`;

export const WrapperPeriodicity = styled.div`
  padding: 10px;
  .subtitle-filter {
    font-size: 14px;
    font-weight: bold;
    margin-left: 5px;
  }
`;


export const WrapperInput = styled.div`
  padding: 10px;
  .subtitle-input {
    font-size: 14px;
    font-weight: bold;
    margin-left: 5px;
  }
`;
